<template>
    <div class="stat-table">
        <h3>{{ title }}</h3>
        <table>
            <thead>
                <tr>
                    <th class="header">{{ headers[0] }}</th>
                    <th class="header">{{ headers[1] }}</th>
                    <th class="header third">{{ headers[2] }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in visibleItems" :key="index">
                    <td class="first">{{ item.first }}</td>
                    <td class="second">{{ item.second }}</td>
                    <td class="third">{{ item.third }}</td>
                </tr>
            </tbody>
        </table>
        <div v-if="showAllVisible" class="show-all" @click="openModal">
            Show all
        </div>

        <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
            <div class="modal-content">
                <div class="modal-header">
                    <h3>All {{ title }}</h3>
                    <button class="modal-close" @click="closeModal">×</button>
                </div>
                <div class="modal-body">
                    <table>
                        <thead>
                            <tr>
                                <th class="header">{{ headers[0] }}</th>
                                <th class="header">{{ headers[1] }}</th>
                                <th class="header third">{{ headers[2] }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in allItems" :key="index">
                                <td class="first">{{ item.first }}</td>
                                <td class="second">{{ item.second }}</td>
                                <td class="third">{{ item.third }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        data: {
            type: Object,
            required: false,
            default: () => ({})
        },
        headers: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            maxItems: 5,
            showModal: false
        };
    },

    computed: {
        visibleItems() {
            return this.allItems.slice(0, this.maxItems);
        },

        allItems() {
            return Object.values(this.data);
        },

        showAllVisible() {
            return Object.entries(this.data).length > this.maxItems;
        }
    },

    methods: {
        openModal() {
            this.showModal = true;
            document.body.style.overflow = 'hidden';
        },

        closeModal() {
            this.showModal = false;
            document.body.style.overflow = '';
        }
    }
};
</script>
